import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { CBSForm } from './form';
@withRouter
@inject('store')
export class CBSView extends Component {
    render() {
        return (
            <CBSForm
                data={
                    (this.props.store.botStore.currentConfiguration.signal_providers &&
                        this.props.store.botStore.currentConfiguration.signal_providers.cbs) ||
                    {}
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SignalsView/CBS/index.js